import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import { GenericDocContainerModel } from 'blg-akaun-ts-lib';
import { Observable } from 'rxjs';
import { SubSink } from 'subsink2';
import { CashbookTxnComponent } from './cashbook-txn/cashbook-txn.component';
import { InvTxnComponent } from './inv-txn/inv-txn.component';
import { JournalTxnComponent } from './journal-txn/journal-txn.component';
import { PointsTxnComponent } from './points-txn/points-txn.component';
import { TaxTxnComponent } from './tax-txn/tax-txn.component';
import { SessionStates } from '../../modules/session/session-controller/states';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-generic-document-posting',
  templateUrl: './generic-document-posting.component.html',
  styleUrls: ['./generic-document-posting.component.css']
})
export class GenericDocumentPostingComponent implements AfterViewInit, OnInit, OnDestroy {

  protected subs = new SubSink();
  selectedIndex = 0;
  @Input() genericDoc$: Observable<any>;
  @Input() orientation: boolean = false;
  private genericDoc: GenericDocContainerModel;
  private isLoadCashbook = false;
  private isLoadTax = false;
  private isLoadPoints = false;
  private isLoadInv = false;

  @ViewChild(MatTabGroup) tabs?: MatTabGroup;
  @ViewChild(JournalTxnComponent, { static: false }) journalTxnComponent: JournalTxnComponent;
  @ViewChild(CashbookTxnComponent, { static: false }) cashbookTxnComponent: CashbookTxnComponent;
  @ViewChild(TaxTxnComponent, { static: false }) taxTxnComponent: TaxTxnComponent;
  @ViewChild(PointsTxnComponent, { static: false }) pointsTxnComponent: PointsTxnComponent;
  @ViewChild(InvTxnComponent, { static: false }) invTxnComponent: InvTxnComponent;

  panels = [
    { title: 'Journal Txn', content: 'journal-txn' },
    { title: 'Cashbook Txn', content: 'cashbook-txn' },
    { title: 'Points Txn', content: 'points-txn' },
    { title: 'Tax Txn', content: 'tax-txn' },
    { title: 'Inv Txn', content: 'inv-txn' }
  ];
  expandedPanelIndex: number = 0;
  
  constructor(private readonly sessionStore: Store<SessionStates>) {
  }

  ngAfterViewInit() {
  }

  ngOnInit(){
    this.subs.sink = this.genericDoc$.subscribe(resolve => {
      this.genericDoc = resolve;
      if(this.journalTxnComponent){
        this.journalTxnComponent.totalCredit = 0;
        this.journalTxnComponent.totalDebit = 0;
        this.journalTxnComponent.createData(this.genericDoc);
      }
    });
  }


  selectTab(e){
    this.selectedIndex = e.index;
    console.log("selectTab", e.index);
    if (e.index === 0) {
      console.log('Load journal');
      this.journalTxnComponent.totalCredit = 0;
      this.journalTxnComponent.totalDebit = 0;
      this.journalTxnComponent.createData(this.genericDoc);
    }
    else if (e.index === 1) {
      //if (!this.isLoadCashbook) {
        console.log('Load Cashbook');
        this.cashbookTxnComponent.createData(this.genericDoc);
        this.isLoadCashbook = true;
      //}
    }
    else if (e.index === 2) {
      //if (!this.isLoadPoints) {
        console.log('Load Points');
        this.pointsTxnComponent.createData(this.genericDoc);
        this.isLoadPoints = true;
      //}
    }
    else if (e.index === 3) {
      //if (!this.isLoadTax) {
        console.log('Load Tax');
        this.taxTxnComponent.createData(this.genericDoc);
        this.isLoadTax = true;
      //}
    }
    else if (e.index === 4) {
      //if (!this.isLoadInv) {
        console.log('Load Inv');
        this.invTxnComponent.createData(this.genericDoc);
        this.isLoadInv = true;
      //}
    }
  }

  onPanelOpened(index: number): void {
    this.expandedPanelIndex = index;
  }

  showPanels(): boolean {
    return this.orientation;
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

}
